import { render, staticRenderFns } from "./ChatBtn.vue?vue&type=template&id=4626855f&scoped=true&"
import script from "./ChatBtn.vue?vue&type=script&lang=js&"
export * from "./ChatBtn.vue?vue&type=script&lang=js&"
import style0 from "./ChatBtn.vue?vue&type=style&index=0&id=4626855f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626855f",
  null
  
)

export default component.exports